<template>
  <div class="published" ref="publish">
    <DynamicItem @deleteMessage="deleteMessage" @thumbsUp="thumbsUp(item)" v-for="item of list" :key="item.id" v-bind="item" />
    <transition name="bounce">
      <div v-show="loading" class="loading">加载过程中</div>
    </transition>
  </div>
</template>
<script>
import DynamicItem from '../../../components/pulishedItem'
import { get } from '../../../utils/request'
import { get as getUser } from '../../../utils/token'
import { isAndroid } from '../../../utils/utils'
export default {
  components: {
    DynamicItem
  },
  data () {
    return {
      isAndroid: isAndroid(),
      list: [],
      loading: false,
      page: 1,
      size: 10,
      count: 0
    }
  },
  activated () {
    this.pageInit()
    this.getPublishedList()
    this.addUpRefresh()
  },
  methods: {
    pageInit () {
      this.loading = false
      this.page = 1
      this.size = 10
      this.count = 0
    },
    addUpRefresh () {
      const el = this.$refs.publish
      const offsetHeight = el.offsetHeight
      el.addEventListener('scroll', () => {
        if (this.loading) {
          return
        }
        const scrollHeight = el.scrollHeight
        const scrollTop = el.scrollTop
        if (offsetHeight + scrollTop >= scrollHeight) {
          const { count, list, page } = this
          if (count > list.length) {
            this.page = page + 1
            el.scrollTop = el.scrollTop - 60
            // this.loading = false
            this.loading = true
            this.getPublishedList()
          }
        }
      })
    },
    thumbsUp () {
      // this.getPublishedList()
    },
    goDetails (item) {
      // set('scrollDynamic', this.$refs.dynamic.scrollTop)
      // console.log('dynamic', this.$refs.dynamic.scrollTop)
      this.$router.push(`/exerland/dynamicTetail/${item.id}`)
    },
    deleteMessage (id) {
      let index = 0
      this.dynamic.forEach((item, _index) => {
        if (Object.is(id, item.id)) {
          index = _index
        }
      })
      this.list.splice(index, 1)
    },
    getPublishedList () {
      this.loading = true
      const user = getUser('user')
      const promise = get({
        url: `/circle/getPublishList/${user.id}?page=${this.page}&size=${this.size}`
      })
      promise.then(res => {
        const { data: { code, detail: { count, data } } } = res
        if (Object.is(code, 200)) {
          if (data.length === 0) {
            this.loading = false
            return
          }
          this.count = count
          this.list.push(...data)
          this.loading = false
        }
      }).catch(() => {
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.published {
  width: 100vw;
  box-sizing: border-box;
  height: 100vh;
  overflow-y: scroll;
  background: #fff;
}
/deep/ .content-item-left {
  margin-right: 24px;
}
</style>
